import {history} from '../store/index';
import {store} from '../../NextApp';
import {generateQueryString} from "../../util/Api";

import {
  CLEAR_PROPS_SUCCESS,
  CREATE_TPWA_SUCCESS,
  FETCH_QUOTATIONS_SUCCESS,
  FETCH_TPW_SNO_SUCCESS,
  SAVE_TPWA_QUERY,
} from "../../constants/ActionTypes";

import axios from 'util/Api'
import {fetchError, fetchStart, fetchSuccess} from "./Common";

export const saveResourceQuery = (query) => {
  return {
    type: SAVE_TPWA_QUERY,
    query
  };
};

export const createResourceSuccess = ({data}) => {
  return {
    type: CREATE_TPWA_SUCCESS,
    data
  };
};

export const clearProps = () => {
  return {
    type: CLEAR_PROPS_SUCCESS
  };
};

export const fetchQuotationsSuccess = ({data, count, disable, quote, history, tpwNo}) => {
  return {
    type: FETCH_QUOTATIONS_SUCCESS,
    data,
    count,
    disable,
    quote,
    history,
    tpwNo,
  };
};

export const fetchTpwResourceSuccess = (data) => {
  return {
    type: FETCH_TPW_SNO_SUCCESS,
    data
  };
};

export const createResource = (payload, redirect = true, module) => {
  return async (dispatch) => {
    dispatch(fetchStart());
    try {
      const response = await axios.post(`/third-party-work-approval`, payload);
      dispatch(fetchSuccess());
        if(response && response.data) {
          dispatch(createResourceSuccess(response.data));
          dispatch(clearProps());
          history.push('/third-party-work-approval');
        }
        else {
          history.push('/third-party-work-approval');
        }
    } catch (error) {
      dispatch(fetchError(error));
      console.log("Error****:", error);
    }
  }
};

export const fetchTpwNo = (data) => {
  return async (dispatch) => {
    dispatch(fetchStart());
    let query = '';
    Object.entries(data).forEach(([key, value], index) => {
      if(Object.keys(data).length - 1 === index) {
        query += `${key}=${value}`
      } else {
        query += `${key}=${value}&`
      }
    });
    try {
      const response = await axios.get(`/third-party-work-approval/tpw?${query}`);
      dispatch(fetchSuccess());
      dispatch(fetchTpwResourceSuccess(response.data));
    } catch (error) {
      dispatch(fetchError(error.response.data.message));
      console.log('Error****:', error.response.data.message);
    }
  };
};

export const cancelTpw = (data = {}) => {
  return async (dispatch) => {
    dispatch(fetchStart());
    try {
      const response = await axios.post(`/third-party-work-approval/cancel`, data);
      dispatch(fetchSuccess());
      if(response && response.data) {
        dispatch(clearProps());
        history.push('/third-party-work-approval');
      }
      else {
        history.push('/third-party-work-approval');
      }
    } catch (error) {
      dispatch(fetchError(error.response.data.message));
      console.log('Error****:', error.response.data.message);
    }
  }
};

export const workDone = (data = {}) => {
  return async (dispatch) => {
    dispatch(fetchStart());
    try {
      const response = await axios.post(`/third-party-work-approval/workDone`, data);
      dispatch(fetchSuccess());
      if(response && response.data) {
        history.push('/third-party-work-requirement');
      }
      else {
        history.push('/third-party-work-order-approval');
      }
    } catch (error) {
      dispatch(fetchError(error.response.data.message));
      console.log('Error****:', error.response.data.message);
    }
  }
};


export const fetchQuotations = (data = '') => {
  return async (dispatch) => {
    dispatch(fetchStart());
    try {
      let disable = false;
      const { thirdPartyWorkApproval } = store.getState();
      const {query} = thirdPartyWorkApproval;
      query.filters = {
        tpwNo: `{"value":["${data}"],"type":"String","field":"tpwNo"}`
      }
      const response = await axios.get(`/third-party-work-approval/quotations?${generateQueryString(query)}`);
      dispatch(fetchSuccess());
      if(response && response.data && response.data.data) {
        await response.data.data.map(quote => {
          if(quote && quote.status === 'Approved') {
            disable = true;
            response.data.disable = disable;
            response.data.quote = quote._id;
          }
        });
      }
      //console.log(response.data);
      dispatch(fetchQuotationsSuccess(response.data));
    } catch (error) {
      dispatch(fetchError(error.response.data.message));
      console.log('Error****:', error.response.data.message);
    }
  }
};
